


















import { Vue, Component, Prop } from 'vue-property-decorator'
import { LifeInsuranceBenefitInfos } from '@/types/newPersion'
import cardTable from '@/common/cardMap/cardLayout/cardTable.vue'
import TsTable from '@/components/TsTable/TsTable.vue'
@Component({
  components: {
    TsTable,
    cardTable,
  },
})
export default class TableWrap extends Vue {
  @Prop() tableData!: LifeInsuranceBenefitInfos[];
  @Prop() tableHead!: {};

  PtableData = {
    data: this.tableData,
  };

  tableTitleObj = {
    title: '',
    options: {
      dropdown: false,
      // type: 'add',
      // name: '新增',
      arr: [
        //   {
        //     type: 'del',
        //     name: '删除'
        //   },
        //   {
        //     type: 'export',
        //     name: '导出'
        //   }
      ],
    },
  };
}
